



































import { formatDate, parseDate } from '@/shareds/date/date-utils'
import { Vue, Component, Ref, PropSync, Watch } from 'vue-property-decorator'

@Component
export default class DatePicker extends Vue {
	@PropSync('value', {
		default: new Date().toISOString().substr(0, 10),
	})
	date!: string | null
	@Ref() menu!: { save: (value: any) => void }

	dataFormatada: string | null = null

	mostrar = false

	parseDate = parseDate

	@Watch('date', { immediate: true })
	onChangeDate() {
		this.dataFormatada = formatDate(this.date)
	}

	onBlur() {
		const normalizada = this.normalizarParaDDMMYYYY(this.dataFormatada)

		this.dataFormatada = normalizada

		this.$emit('input', normalizada ? this.parseDate(normalizada) : null)
	}

	private normalizarParaDDMMYYYY(valor: string | null): string {
		if (!valor) return ''

		const v = String(valor).trim()
		if (!v) return ''

		if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) return v

		const digits = v.replace(/\D/g, '').slice(0, 8)
		if (digits.length === 8) {
			return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
		}

		return ''
	}
}
